import { getSocialMediaData } from '../../cms/layout/constants';

export const enum ALIGN {
  left = 'left',
  right = 'right',
}

export interface SOCIAL_MEDIA {
  linkedin?: string | null;
  twitter?: string | null;
  facebook?: string | null;
  whatsapp?: string | null;
}
interface SOCIAL_MEDIA_PROPS extends SOCIAL_MEDIA {
  align?: ALIGN;
}
export const SocialMedia = ({
  linkedin = '',
  facebook = '',
  twitter = '',
  whatsapp = '',
  align = ALIGN.left,
}: SOCIAL_MEDIA_PROPS): JSX.Element => {
  const socialShare = (href: string) => {
    window.open(
      href,
      '',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
    return false;
  };

  const socialMediaData = getSocialMediaData({
    linkedin,
    facebook,
    twitter,
    whatsapp,
  });

  return (
    <div
      data-testid="social-media"
      className={`flex align-middle w-full clear-both shareBlock mt-0 ${
        align === ALIGN.right ? 'justify-end' : ''
      }`}
    >
      {socialMediaData.map((item) => {
        if (!item.link) return null;

        return (
          <a
            key={item.name}
            className="sm:px-0"
            href={item.link}
            id={`${item.name}Share`}
            data-action={`${item.action || ''}`}
            onClick={() => socialShare(item.link)}
            target="_blank"
            rel="noopener noreferrer"
            title={`share on ${item.name}`}
          >
            <img
              width="32"
              height="32"
              src={item.icon}
              alt="social icons"
              className="img-responsive m-2"
            />
          </a>
        );
      })}
    </div>
  );
};
